import { useQuery } from '@tanstack/react-query';
import { getProviderDetails } from '@uplift/api';

import { providerQueryKeys } from './providerQueryKeys';
import { BaseQueryOpts } from '../baseTypes';


export const useProviderDetailsQuery = (providerId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: providerQueryKeys.details(providerId),
    queryFn: async () => {
      const details = await getProviderDetails(providerId);

      return details.data;
    },
    ...opts,
  });
};
